import ReloadPrompt from '@/components/ReloadPrompt';
import '@/styles/main.css';
import i18n from '@/translations/config';
import { appRouter } from '@/utils/router';
import * as Sentry from '@sentry/react';
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { Toaster } from 'react-hot-toast';
import { I18nextProvider } from 'react-i18next';
import { RouterProvider } from 'react-router-dom';
import { Loading } from './components/Loading';
import OfflineIndicator from './components/OfflineIndicator';

Sentry.init({ dsn: import.meta.env.VITE_SENTRY_DSN });

export const App = () => {
  return (
    <I18nextProvider i18n={i18n}>
      <Suspense fallback={<Loading />}>
        <Toaster
          position="top-right"
          reverseOrder={false}
          gutter={8}
          containerClassName=""
          containerStyle={{}}
          toastOptions={{
            // Define default options
            className: '',
            duration: 4000,
            style: {
              background: '#ffffff',
              color: '#374151',
              borderRadius: '12px',
              boxShadow:
                '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
              border: '1px solid #e5e7eb',
              padding: '16px',
              fontSize: '14px',
              fontWeight: '500',
            },
            // Customize icons and styles for different toast types
            success: {
              duration: 4000,
              style: {
                background: '#f0fdff',
                color: '#0c4a6e',
                border: '1px solid #0ea5e9',
                boxShadow:
                  '0 10px 15px -3px rgba(14, 165, 233, 0.1), 0 4px 6px -2px rgba(14, 165, 233, 0.05)',
              },
              iconTheme: {
                primary: '#0ea5e9',
                secondary: '#f0fdff',
              },
            },
            error: {
              duration: 5000,
              style: {
                background: '#fef2f2',
                color: '#991b1b',
                border: '1px solid #ef4444',
                boxShadow:
                  '0 10px 15px -3px rgba(239, 68, 68, 0.1), 0 4px 6px -2px rgba(239, 68, 68, 0.05)',
              },
              iconTheme: {
                primary: '#ef4444',
                secondary: '#fef2f2',
              },
            },
            loading: {
              duration: Infinity,
              style: {
                background: '#f8fafc',
                color: '#475569',
                border: '1px solid #cbd5e1',
                boxShadow:
                  '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
              },
              iconTheme: {
                primary: '#0ea5e9',
                secondary: '#f8fafc',
              },
            },
          }}
        />

        <OfflineIndicator />
        <ReloadPrompt />
        <RouterProvider
          router={appRouter}
          future={{ v7_startTransition: true }}
        />
      </Suspense>
    </I18nextProvider>
  );
};

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
